import Soundcloud6 from './Soundcloud6'
export default Soundcloud6
